var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttenteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_107",
    "data-name": "Groupe 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.078,
    height: 47.365,
    viewBox: "0 0 36.078 47.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 36.078,
    height: 47.365,
    fill: "#202b53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_94",
    "data-name": "Groupe 94",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_514",
    "data-name": "Trac\\xE9 514",
    d: "M32.96,39.172l-2.646-7.937a12.886,12.886,0,0,0-6.448-7.464,13.4,13.4,0,0,0,6.448-7.64c.278-.837,2.367-7.1,2.646-7.937A4.163,4.163,0,0,0,31.915,0H4.163A4.163,4.163,0,0,0,3.118,8.193c.279.835,2.367,7.1,2.646,7.937a13.385,13.385,0,0,0,6.447,7.639,12.881,12.881,0,0,0-6.447,7.465L3.118,39.172a4.163,4.163,0,0,0,1.045,8.193H31.915a4.163,4.163,0,0,0,1.045-8.193M4.163,5.551a1.388,1.388,0,0,1,0-2.775H31.915a1.388,1.388,0,0,1,0,2.775ZM6.088,8.326h23.9l-1.85,5.551H7.938Zm2.887,8.317H27.1a10.326,10.326,0,0,1-5.268,5.01c-.272.109-.046-.05-3.788,3.081-3.582-3.053-3.382-2.917-3.676-3.031a10.309,10.309,0,0,1-5.4-5.061M8.4,32.112a10.115,10.115,0,0,1,6.47-6.442l2.272,1.936a1.388,1.388,0,0,0,1.79.008l2.312-1.935a10.12,10.12,0,0,1,6.439,6.433l2.309,6.927H25.214c-1.121-3.365-3.635-8.326-7.175-8.326s-6.054,4.962-7.176,8.326H6.088Zm13.885,6.927H13.8a16.48,16.48,0,0,1,1.867-3.619c.854-1.209,1.742-1.932,2.376-1.932s1.523.722,2.376,1.932a16.472,16.472,0,0,1,1.867,3.619m9.633,5.551H4.163a1.388,1.388,0,0,1,0-2.775H31.915a1.388,1.388,0,0,1,0,2.775",
    transform: "translate(0 0)",
    fill: "#202b53"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttenteIcon);
export default __webpack_public_path__ + "static/media/attente-icon.062ca0cfb5c273cb6d33dd06005af6de.svg";
export { ForwardRef as ReactComponent };